import { defineStore } from "pinia";

export const useCheckoutStore = defineStore("checkout", {
  state: () => ({
    fullGame: null,
    fullPack: null,
    game: null,
    pack: null,
    packOptions: [],
    packExtraOptions: {},
    heroes: [],
    roles: [],
    platform: null,
    currency: null,
    booster: null,
    server: {},
    coupon: null,
    tier: {},
    details: {},
    queue: {},
    role: null,
    payment_method: null,
    price: 0,
    basePrice: 0,
    time: 0,
    badges: [],
    confidence: 0,
    progressiveDiscountSlabs: [],
    cartErrors: {},
    becomeLegend: false,
    becomeGladiator: false,
    dungeons: [],
    armorType: "",
    raidDates: [],
    raid: null,
    startCalculating: false,
    camoWeapon: [],
    camoCategory: null,
    camoSpecials: null,
    realms: [],
    difficulty: null,
    trials: [],
    boostMethod: null,
    addOn: [],
    deliveryOption: null,
    otherConfig: {},
  }),

  getters: {
    getCartGame: (state) => state.game,
    getDetails: (state) => state.details,
    getSelectedPack: (state) => state.pack,
    getSelectedBooster: (state) => state.booster,

    getSelectedCoupon: (state) => state.coupon,
    getPackExtraOptions: (state) => state.packExtraOptions,
    getPackOptions: (state) => state.packOptions,
    getSelectedRoles: (state) => state.roles,

    getSelectedHeros: (state) => state.heroes,
    getSelectedTier: (state) => state.tier,
    getSelectedPlatform: (state) => state.platform,
    getSelectedQueue: (state) => state.queue,

    getSelectedPaymentMethod: (state) => state.payment_method,
    getSelectedServer: (state) => state.server,
    getSelectedBadges: (state) => state.badges,
    getConfidence: (state) => state.confidence,

    getProgressDiscountSlabs: (state) => state.progressiveDiscountSlabs,
    getSelectedRole: (state) => state.role,
    getCartErrors: (state) => state.cartErrors,
    getBecomeLegend: (state) => state.becomeLegend,

    getBecomeGaldiator: (state) => state.becomeGladiator,
    getSelectedDungeons: (state) => state.dungeons,
    getArmorType: (state) => state.armorType,
    getRaidDates: (state) => state.raidDates,
    getSelectedRaid: (state) => state.raid,
    getBasePrice: (state) => state.basePrice,
    getCamoWeapon: (state) => state.camoWeapon,
    getCamoCategory: (state) => state.camoCategory,
    getCamoSpecials: (state) => state.camoSpecials,
    getSelectedRealms: (state) => state.realms,
    getDifficulty: (state) => state.difficulty,
    getBoostMethod: (state) => state.boostMethod,
    getTrial: (state) => state.trials,
    getAddOn: (state) => state.addOn,
    getDeliveryOption: (state) => state.deliveryOption,
    getOtherConfig: (state) => state.otherConfig,
  },

  actions: {
    setOtherConfig(payload) {
      this.$patch({
        otherConfig: payload,
      });
    },
    setDeliveryOption(payload) {
      this.$patch({
        deliveryOption: payload,
      });
    },
    setAddOn(payload) {
      this.$patch({
        addOn: payload,
      });
    },
    setTrial(payload) {
      this.$patch({
        trials: payload,
      });
    },
    setDifficulty(payload) {
      this.$patch({
        difficulty: payload,
      });
    },
    setBoostMethod(payload) {
      this.$patch({
        boostMethod: payload,
      });
    },
    setRealms(payload) {
      if (this.realms?.includes(payload)) {
        const others = this.realms?.filter((realm) => realm !== payload);
        this.$patch({
          realms: [...others],
        });
        return;
      }

      this.$patch({
        realms: [payload],
      });
    },
    clearRealms() {
      this.$patch({
        realms: [],
      });
    },
    setGameAndPack(payload) {
      this.$patch({
        game: payload.game,
        pack: payload.fullPack?.id,
        fullGame: payload.fullGame,
        fullPack: payload.fullPack,
      });
    },
    setBasePrice(payload) {
      this.$patch({
        basePrice: payload,
      });
    },
    setDetails(payload) {
      this.$patch({
        details: {
          ...payload,
        },
      });
    },

    setServer(payload) {
      this.$patch({
        server: {
          value: payload,
        },
      });
    },
    setPackExtraOptions(payload) {
      this.$patch({
        packExtraOptions: { ...this.$state.packExtraOptions, ...payload },
      });
    },
    setTier(payload) {
      this.$patch({
        tier: {
          value: payload,
        },
      });
    },
    setPackOptions(payload) {
      this.$patch({
        packOptions: [...payload.options],
      });
    },
    removePackOption(payload) {
      const options = this.$state.packOptions.filter(
        (option) => !payload.optionIds.includes(option)
      );

      this.$patch({
        packOptions: [...options],
      });
    },
    clearRoles(payload) {
      this.$state.roles = [];
    },
    clearHeroes(payload) {
      this.$state.heroes = [];
    },
    setRoles(payload) {
      let prevRoles = this.$state.roles;
      let newRoles = [];
      const selectedRole = payload.role;
      const roleExist = prevRoles.findIndex((role) => role === selectedRole);

      if (selectedRole === 14) {
        this.$state.roles = [selectedRole];
        return;
      }
      if (prevRoles.includes(14)) {
        prevRoles = [];
      }
      if (prevRoles.length === 2 && roleExist < 0) {
        newRoles = [prevRoles[1], selectedRole];
      } else if (prevRoles.length === 1 && roleExist < 0) {
        newRoles = [...prevRoles, selectedRole];
      } else if (roleExist < 0) {
        newRoles = [selectedRole];
      } else if (roleExist >= 0) {
        const otherRoles = prevRoles.filter((role) => role !== selectedRole);
        newRoles = [...otherRoles];
      }
      this.$state.roles = [...newRoles];
    },
    setHero(payload) {
      const championId = payload.championId;
      if (!this.$state.heroes.includes(championId)) {
        this.$state.heroes = [...this.$state.heroes, championId];
      } else {
        const otherHeros = this.$state.heroes.filter(
          (hero) => hero !== championId
        );
        this.$state.heroes = [...otherHeros];
      }

      if (this.$state.cartErrors["champions_error"]) {
        delete this.$state.cartErrors["champions_error"];
      }
    },
    clearHeroes(payload) {
      this.$state.heroes = [];
    },
    setOneHero(payload) {
      const championId = payload.championId;
      if (!this.$state.heroes.includes(championId)) {
        this.$state.heroes = [championId];
      } else {
        const otherHeros = this.$state.heroes.filter(
          (hero) => hero !== championId
        );
        this.$state.heroes = [];
      }
    },
    setOneHeroOther(payload) {
      const championId = payload.championId;
      this.$state.heroes = [championId];
    },
    setPlatform(payload) {
      const { key, platform } = payload;
      this.$state.platform = platform;
    },
    setOneRole(payload) {
      const roleId = payload.roleId;
      if (!this.$state.roles.includes(roleId)) {
        this.$state.roles = [roleId];
      } else {
        this.$state.heroes = [];
      }
    },

    setQueue(payload) {
      this.$state.queue = {
        value: payload,
      };
    },
    setRole(payload) {
      this.$state.role = payload;
    },
    clearCheckout(payload) {
      this.$patch({
        details: null,
      });
      this.$patch({
        game: null,
        pack: null,
        fullGame: null,
        fullPack: null,
        packOptions: [],
        packExtraOptions: [],
        heroes: [],
        roles: [],
        platform: null,
        currency: null,
        booster: null,
        server: {},
        // coupon: null,
        queue: null,
        details: {},
        tier: {},
        payment_method: null,
        badges: [],
        progressiveDiscountSlabs: [],
        role: null,
        cartErrors: {},
        becomeLegend: false,
        becomeGladiator: false,
        dungeons: [],
        armorType: "",
        raidDates: [],
        raid: null,
        startCalculating: false,
        basePrice: 0,
        price: 0,
        camoWeapon: [],
        camoCategory: null,
        camoSpecials: null,
        realms: [],
        difficulty: null,
        boostMethod: null,
        trials: [],
        addOn: [],
        deliveryOption: null,
      });
    },
    setCamoCategory(payload) {
      this.$state.camoCategory = payload;
      this.$state.camoSpecials = null;
    },
    clearDetails(payload) {
      this.$state.details = {};
    },
    setBadges(payload) {
      const badgeId = payload.badgeId;
      if (!this.$state.badges.includes(badgeId)) {
        this.$state.badges = [...this.$state.badges, badgeId];
      } else {
        const otherHeros = this.$state.badges.filter(
          (hero) => hero !== badgeId
        );
        this.$state.badges = [...otherHeros];
      }
    },
    setBooster(payload) {
      this.$state.booster = payload;
    },
    setCalculating() {
      const router = useRouter();
      if (router.currentRoute.value?.params?.gameSlug) {
        const query = router.currentRoute.value?.query["booster-id"] || null;
        this.$state.booster = query;
      }
      this.$state.startCalculating = true;
    },
    setCoupon(payload) {
      this.$state.coupon = {
        ...payload,
      };
    },
    removeCoupon(payload) {
      this.$state.coupon = null;
    },
    setBecomeLegend(payload) {
      this.$state.becomeLegend = payload;
    },
    setBecomeGladiator(payload) {
      this.$state.becomeGladiator = payload;
    },
    setArmorType(payload) {
      this.$state.armorType = payload;
    },
    setCamoWeapon(payload) {
      this.$patch({
        camoSpecials: null,
        camoWeapon: payload,
      });
    },

    setCamoSpecials(payload) {
      this.$patch({
        camoSpecials: payload,
        camoWeapon: [],
        camoCategory: null,
      });
    },

    setDungeons(payload) {
      this.$state.dungeons = [...payload];
    },
    setAllDungeons(payload) {
      this.$state.dungeons = [...payload];
    },
    setRaid(payload) {
      this.$state.raid = payload;
    },
    setRaidDates(payload) {
      this.$state.raidDates = payload;
    },
    removeAllPackOptions(payload) {
      this.$state.packOptions = [];
    },
    removeExtraPackOptions(key) {
      const options = { ...this.$state.packExtraOptions };
      delete options[key];
      this.$state.packExtraOptions = { ...options };
    },
  },
});
